enum DocumentCategoryFieldNames {
  Id = 'id',
  Color = 'color',
  Name = 'name',
  Description = 'description',
}

export default DocumentCategoryFieldNames;
